import type { IconData } from '@stacksjs/iconify-core'

export const noPhotoTakingZone: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M2 3c9.37 0 17.026 7.532 17.519 17.012l4.156 6.307c.518.785.427 1.823-.349 2.338c-.864.573-2.198 1.26-4.053 1.686l-.575 7.002c-.148 1.797-1.762 3.081-3.497 2.781l-4.68-.809V46m34.039 0a32 32 0 0 0 .983-3.86c.518-2.743-1.029-5.331-3.66-6.267a53 53 0 0 0-5.867-1.691c0-1.424-.237-4.666-.402-6.748c-.092-1.154-.846-2.176-1.991-2.349A7 7 0 0 0 32.565 25c-.371 0-.744.036-1.092.09c-1.127.175-1.87 1.172-1.936 2.31c-.094 1.66-.205 4.453-.205 8.457l-1.191 1.114c-1.351 1.263-2.09 3.089-1.727 4.903c.337 1.687.793 3.051 1.257 4.126\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default noPhotoTakingZone
